import { ImageUrlsByPlatform, LocalizedImageUrlsByPlatform, PlatformType } from '../../common';

export const getImgUrlByPlatform = (platformType: PlatformType, images: ImageUrlsByPlatform[]): string | undefined => {
  return images.find((val) => val.platform === platformType)?.imageUrl;
};

export const getImgUrlByLocalizedPlatform = (
  platformType: PlatformType,
  images: LocalizedImageUrlsByPlatform[],
  lang: string
): string | undefined => {
  return images.find((val) => val.platform === platformType)?.imageUrl?.[lang];
};
